import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/dashboard/admin/integrations",
)({
	beforeLoad: () => {
		throw redirect({ to: "/settings/org/integrations" });
	},
});
